import { createFileRoute, Navigate } from '@tanstack/react-router';

/** «Formazione» è la scheda «Corsi e certificazioni» di «Scadenze» dal 03-11-2026: l'indirizzo resta per i segnalibri. */
export const Route = createFileRoute('/_app/workforce/training')({
  component: () => <Navigate to="/hr/deadlines" search={{ tab: 'training' }} replace />,
});
